<template>
  <section>
    <div class="clearfix documentSmallItem">
      <div class="logo">
        <div class="cover-small">
          <div class="cover-image-container">
            <div class="cover-outer-align">
              <div class="cover-inner-align">
                <i class="fal fa-file-alt" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information w-light">
        <router-link
          :to="{ name: 'Document', params: { dclIdentity: item.dclIdentity}}"
        >{{item.name}} {{item.version}}</router-link>

        <b-nav small align="right" tag="ul" class="float-right" v-if="!showMinimal">
          <b-nav-item>
            <i
                class="fal fa-file-times"
                @click="removeDocument"
                v-b-tooltip.hover
                :title="$t('SERVICES.REMOVE_DOCUMENT')"
              /></b-nav-item>
        </b-nav>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ["item", "showMinimal","serviceId"],
  data() {
    return {
      details: this.item,
      publishedDetails: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    removeDocument() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/services/documents/remove", {
          serviceId: this.serviceId,
          dclIdentity: this.details.dclIdentity
        })
        .then(function() {
          self.$emit("removedDocument");
          self.$noty.info(self.$t("SERVICES.REMOVED_DOCUMENT"));
        })
        .catch(function() {
          self.$noty.error(self.$t("SERVICES.ERROR.COULD_NOT_REMOVE_DOCUMENT"));
        });
    }
  },
  computed: {
    documentUrl() {
      return (
        process.env.VUE_APP_FRONTEND +
        "/document/" +
        this.details.documentVersion.dclIdentity
      );
    }
  }
};
</script>
<style>
</style>